import { FaBars, FaTimes, FaHome, FaChartBar } from 'react-icons/fa';
import { CiLogin, CiLogout } from "react-icons/ci";
import { useRef } from 'react';
import '../styles/main.css';
import myImage from '../assets/images/logo.png'
import { useAuth } from '../context/AuthProvider';
import { Link } from 'react-router-dom';
import { FaBell } from "react-icons/fa6";
import { useState } from 'react';
import { useNotifications } from '../context/NotificationsProvider';
import api from '../api/NotificationReq';
import { toast } from 'sonner';


const Navbar = () => {
    const navRef = useRef();
    const { isAuthenticated } = useAuth();


    const showNavBar = () => {
        navRef.current.classList.toggle("responsive_nav")
    }

    const closeNavBar = () => {
        navRef.current.classList.remove("responsive_nav");
    };

    const { notifications, notificationsNotRead, setNotifications, setNotificationsNotRead } = useNotifications();

    const [isBellClicked, setIsBellClicked] = useState(false);
    const handleNotificationBell = () => setIsBellClicked(state => !state);

    const messageColor = (msg) => {
        if (msg.process_state === "STARTED") {
            return 'notification-square-message notification-square-backgorund-started';
        } else if (msg.process_state === "IN_PROGRESS") {
            return 'notification-square-message notification-square-backgorund-in_progress';
        } else if (msg.process_state === "COMPLETED") {
            return 'notification-square-message notification-square-backgorund-completed';
        } else if (msg.process_state === "FAILED") {
            return 'notification-square-message notification-square-backgorund-failed';
        }
    }

    const messageRead = (msg) => {
        return msg.is_read ? '': 'notification-text-bolder' 
    }

    const handleMarkRead = async (id) => {
        const notificationIsRead = notifications.filter((notification) => (notification.id === id))[0].is_read;
        if (notificationIsRead)
            return

        try {
            const response = await api.put(`/${id}`, {}, {withCredentials: true});
            if (response.data.success) {
                setNotifications((prev) => prev.map((msg) => {
                if (msg.id === id && !msg.is_read) {
                    msg.is_read = true
                    setNotificationsNotRead((prev) => prev - 1);
                }                
                return msg
                }));
            }
            else {
                console.log(response.data.error);
            }
        }
        catch (err) {
            toast.error('Error! Not correct response from database!')
            console.log(err)
        }
    }

    return (
        <header>
            <nav ref={navRef}>
                <Link to='/menu' onClick={closeNavBar}><img src={myImage} height="45" alt=""/></Link>
                {isAuthenticated ? <Link to='/menu' onClick={closeNavBar} className='nav-link-center'><FaHome /> &nbsp; Menu</Link> : null}
                {isAuthenticated ? <Link to='/choice' onClick={closeNavBar} className='nav-link-center'><FaChartBar /> &nbsp; Choice</Link> : null}
                {isAuthenticated ? <Link to='/logout' onClick={closeNavBar} className='nav-link-center'><CiLogout /> &nbsp; Logout</Link> : null}
                {!isAuthenticated ? <Link to='/flexp-login' onClick={closeNavBar} className='nav-link-center'><CiLogin /> &nbsp; Login</Link> : null}
                
                <button className="nav-btn nav-close-btn" onClick={showNavBar}>
                    <FaTimes className='nav_button_color'/>
                </button>
            </nav>
            <div style={{position: 'relative'}}>
                <FaBell 
                    className='notification-bell'
                    onClick={handleNotificationBell}
                />
                <div className='notification-square'>{notificationsNotRead}</div>
                <button className="nav-btn" onClick={showNavBar}>
                    <FaBars className='nav_button_color'/>
                </button>
                <div className='notification-message-container'>
                    {isBellClicked && notifications.map((msg) => {
                        return <div
                                className={messageColor(msg)}
                                key={msg.id}
                                onClick={() => handleMarkRead(msg.id)}
                            >
                                <div className="notification-square-time-process-state">
                                    <div className={messageRead(msg)}>{msg.created_at}</div>
                                    <div className={messageRead(msg)}>{msg.process_state}</div>
                                </div>
                                <div className={messageRead(msg)} style={{textAlign: "justify"}}>
                                    {msg.title}<br />
                                    {msg.description? msg.description : null}
                                </div>
                            </div>
                    })}
                </div>
            </div>
        </header>
    )
}

export default Navbar;